import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ChatPanel } from "./ChatPanel";
import { ChatErrorBoundary } from "./ChatErrorBoundary";
import { MentorIcon } from "./MentorIcon";
import { useChatContext } from "./ChatProvider";
import { cn } from "@/lib/utils";

export function ChatFAB() {
  const [isOpen, setIsOpen] = useState(false);
  const { isStreaming } = useChatContext();

  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <ChatErrorBoundary>
            <ChatPanel onClose={() => setIsOpen(false)} />
          </ChatErrorBoundary>
        )}
      </AnimatePresence>

      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={() => setIsOpen((prev) => !prev)}
            className={cn(
              "fixed z-50 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-all hover:scale-105 active:scale-95",
              isOpen
                ? "bottom-3 right-3 sm:bottom-6 sm:right-6"
                : "bottom-6 right-6",
              isStreaming && !isOpen && "animate-pulse",
              isOpen && "ring-2 ring-primary/30",
            )}
            aria-label={isOpen ? "Fechar chat" : "Chat com IA"}
          >
            <AnimatePresence mode="wait" initial={false}>
              {isOpen ? (
                <motion.div
                  key="close"
                  initial={{ rotate: -90, opacity: 0 }}
                  animate={{ rotate: 0, opacity: 1 }}
                  exit={{ rotate: 90, opacity: 0 }}
                  transition={{ duration: 0.15 }}
                >
                  <X className="h-6 w-6" />
                </motion.div>
              ) : (
                <motion.div
                  key="chat"
                  initial={{ rotate: 90, opacity: 0 }}
                  animate={{ rotate: 0, opacity: 1 }}
                  exit={{ rotate: -90, opacity: 0 }}
                  transition={{ duration: 0.15 }}
                >
                  <MentorIcon size={28} />
                </motion.div>
              )}
            </AnimatePresence>
          </button>
        </TooltipTrigger>
        {!isOpen && <TooltipContent side="left">Chat com IA</TooltipContent>}
      </Tooltip>
    </>
  );
}
